import axios from "axios";

class LocTok {
    constructor() {
        this.storedTk = localStorage.getItem("tk");
        this.rtk = null;
        this.atk = null;
        this.refreshAtkAvailAttempts = 0;
        this.refreshAtkAttempts = 0;
        this.history = null;
        this.token = null;
    }
    isLocTokValid() {
        try {
            if (this.storedTk) {
                let storedTk = JSON.parse(this.base64decode(this.storedTk));
                console.log(storedTk)
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error(error);
            return false;
        }
    }
    getTksFrmLoc() {
        let storedTk = JSON.parse(this.base64decode(this.storedTk));
        this.rtk = this.base64decode(storedTk["rtk"]);
        this.atk = this.base64decode(storedTk["atk"]);
    }
    updateAtkToLoc(atk,rtk) {
        let metaData = {
            atk: this.base64encode(atk),
            rtk: this.base64encode(rtk)
        };
        localStorage.setItem("tk", this.base64encode(JSON.stringify(metaData)));
        console.log("Token Updated");
    }
    login() {
        window.location.href = "/login/";
    }
    revokeAccessTk() {
        const currentPointer = this;
        let url = "/api/user/logout/access";
        let data = {};
        let headers = {
            headers: {
                Authorization: "Bearer " + currentPointer.atk,
            },
        };
        axios
            .post(url, data, headers)
            .then((response) => {
                if (response.data.message == "Access token has been revoked") {
                    console.log(response.message);
                    currentPointer.revokeRefreshTk();
                }
            })
            .catch((error) => {
                console.log(error);
                currentPointer.revokeRefreshTk();
            });
    }
    revokeRefreshTk() {
        const currentPointer = this;
        let url = "/api/user/logout/refresh";
        let data = {};
        let headers = {
            headers: {
                Authorization: "Bearer " + currentPointer.rtk,
            },
        };
        axios
            .post(url, data, headers)
            .then((response) => {
                if (response.data.message == "Refresh token has been revoked") {
                    currentPointer.directLogout();
                    console.log(response.message);
                }
            })
            .catch((error) => {
                console.log(error);
                currentPointer.directLogout();
            });
    }
    clearSession(token = null) {
        this.token = token;
        const currentPointer = this;
        let url = "/api/user/logout";
        axios
            .post(url)
            .then((response) => {
                console.log(response);
                currentPointer.directLogout();
            })
            .catch((error) => {
                console.log(error);
                currentPointer.directLogout();
            });
    }
    logout(token = null) {
        this.token = token;
        this.revokeAccessTk();
    }
    clearLocalStorage() {
        localStorage.clear();
    }
    directLogout() {
        this.clearLocalStorage();
        console.log(this.token);
        let logoutInitiated = false;
        console.log("In Direct logout");
        if (!logoutInitiated) {
            logoutInitiated = true;
            if (this.token == "Token not found") {
                window.location.reload();
                console.log(this.token);
            } else {
                window.location.href = "/";
                if (this.history) {
                    console.log("History Available");
                }
                console.log("In direct reload page");
            }
        }
    }
    reloadPage() {
        window.location.reload();
    }
    refreshAtk() {
        const currentPointer = this;
        let url = "/api/user/token/refresh";
        let headers = {
            headers: {
                Authorization: "Bearer " + currentPointer.rtk,
            },
        };
        let data = {};
        return axios
            .post(url, data, headers)
            .then((response) => {
                console.log(response);
                let responseKeys = Object.keys(response.data);
                if (responseKeys.includes("access_token") && responseKeys.includes("refresh_token")) {
                    console.log("ATK : REFRESHED");
                    currentPointer.updateAtkToLoc(response.data.access_token,response.data.refresh_token);
                }
            })
            .catch((error) => {
                console.log(error);
                let errorMsg = error.response.data.message;
                switch (errorMsg) {
                    case "Token has expired":
                        if (
                            currentPointer.refreshAtkAttempts <
                            currentPointer.refreshAtkAvailAttempts
                        ) {
                            currentPointer.refreshAtkAttempts++;
                            currentPointer.refreshAtk();
                        } else {
                            currentPointer.logout();
                        }
                        break;
                    default:
                        currentPointer.logout();
                }
            });
    }
    base64encode(arg) {
        return window.btoa(arg);
    }
    base64decode(arg) {
        return window.atob(arg);
    }
}

export default LocTok;
